import styled from 'styled-components/macro';

export const StyledFilesListWrapper = styled.div`
  max-height: 70px;
  overflow-y: auto;
`;
